const CATEGORY_SLUG_DISPLAY_TO_REAL_MAPPING = {
  creative: "elevencreative-stories",
  api: "elevenapi-stories",
  agents: "elevenagents-stories",
} as const;

const CATEGORY_SLUG_REAL_TO_DISPLAY_MAPPING = {
  "elevencreative-stories": "creative",
  "elevenapi-stories": "api",
  "elevenagents-stories": "agents",
} as const;

export function getDisplayCategorySlug(categorySlug: string): string {
  return (
    CATEGORY_SLUG_REAL_TO_DISPLAY_MAPPING[categorySlug as keyof typeof CATEGORY_SLUG_REAL_TO_DISPLAY_MAPPING] ??
    categorySlug
  );
}

export function getRealCategorySlug(categorySlug: string): string {
  return (
    CATEGORY_SLUG_DISPLAY_TO_REAL_MAPPING[categorySlug as keyof typeof CATEGORY_SLUG_DISPLAY_TO_REAL_MAPPING] ??
    categorySlug
  );
}
